import React from "react";
import { createPortal } from "react-dom";
import TaskForm from "../TaskForm";

function TaskModal({
  show,
  onClose,
  title,
  setTitle,
  details,
  setDetails,
  priority,
  setPriority,
  startDate,
  setStartDate,
  startTime,
  setStartTime,
  deadlineDate,
  setDeadlineDate,
  deadlineTime,
  setDeadlineTime,
  taskType,
  setTaskType,
  assignedTeam,
  setAssignedTeam,
  householdMemberId,
  setHouseholdMemberId,
  reminderOffset,
  setReminderOffset,
  busy,
  setBusy,
  isPersonal,
  setIsPersonal,
  meetingType,
  setMeetingType,
  location,
  setLocation,
  recurrence,
  setRecurrence,
  project,
  setProject,
  editingId,
  onSubmit,
  taskTypes,
  createMeeting,
  setCreateMeeting,
  clashWarning,
  onSaveAnyway,
  onChangeTime,
}) {
  if (!show) return null;

  // ✅ Validate all incoming props — especially priority — before using .toLowerCase()
  const safeTitle = title || '';
  const safePriority = priority || 'medium';
  const safeEditingId = editingId || null;

  // ✅ Variables Required for meeting link UI logic
  let userProfile = {};
  try { userProfile = JSON.parse(localStorage.getItem("userProfile") || "{}"); } catch { /* use empty default */ }
  const defaultMeetingType = userProfile?.preferences?.defaultMeetingType || ""; // e.g., "Zoom", "Google Meet"
  const isZoomConnected = userProfile?.integrations?.zoomConnected || false;

  return createPortal(
    <div className="modal-overlay">
      <div className={`task-modal ${safePriority.toLowerCase()}`}>
        {/* Close button only — title is not needed */}
        <button
          className="close-btn"
          onClick={onClose}
          aria-label="Close modal"
          type="button"
          style={{ position: 'absolute', top: 16, right: 16 }}
        >
          ×
        </button>

        <TaskForm
          title={safeTitle}
          setTitle={setTitle}
          details={details}
          setDetails={setDetails}
          priority={safePriority}
          setPriority={setPriority}
          startDate={startDate}
          setStartDate={setStartDate}
          startTime={startTime}
          setStartTime={setStartTime}
          deadlineDate={deadlineDate}
          setDeadlineDate={setDeadlineDate}
          deadlineTime={deadlineTime}
          setDeadlineTime={setDeadlineTime}
          taskType={taskType}
          setTaskType={setTaskType}
          assignedTeam={assignedTeam}
          setAssignedTeam={setAssignedTeam}
          householdMemberId={householdMemberId}
          setHouseholdMemberId={setHouseholdMemberId}
          reminderOffset={reminderOffset}
          setReminderOffset={setReminderOffset}
          busy={busy}
          setBusy={setBusy}
          isPersonal={isPersonal}
          setIsPersonal={setIsPersonal}
          meetingType={meetingType}
          setMeetingType={setMeetingType}
          location={location}
          setLocation={setLocation}
          recurrence={recurrence}
          setRecurrence={setRecurrence}
          project={project}
          setProject={setProject}
          editingId={safeEditingId}
          onSubmit={onSubmit}
          taskTypes={taskTypes}
          onCancel={onClose}
          clashWarning={clashWarning}
          onSaveAnyway={onSaveAnyway}
          onChangeTime={onChangeTime}
        />

        {/* ✅ Meeting Link UI Logic */}
        {createMeeting && (
          <div style={{ marginTop: '1rem', padding: '1rem', border: '1px solid #e3f2fd', borderRadius: '8px', background: '#f8f9ff' }}>
            {defaultMeetingType === "Google Meet" && (
              <div className="meeting-preview">
                📎 Google Meet link will be generated automatically
              </div>
            )}

            {defaultMeetingType === "Zoom" && !isZoomConnected && (
              <div className="meeting-warning">
                ⚠️ Please connect Zoom in your profile settings
              </div>
            )}

            {defaultMeetingType === "Zoom" && isZoomConnected && (
              <div className="meeting-preview">
                📎 Zoom link will be generated automatically
              </div>
            )}

            {defaultMeetingType === "Teams" && (
              <div className="meeting-preview">
                📎 Microsoft Teams link will be generated automatically
              </div>
            )}

            {!defaultMeetingType && (
              <div className="meeting-options">
                <label className="section-label">Select Meeting Service</label>
                <div className="meeting-buttons">
                  <button
                    type="button"
                    onClick={() => setMeetingType("Google Meet")}
                    style={{
                      marginRight: '0.5rem',
                      backgroundColor: '#f1f2f4',
                      padding: '0.4rem 0.8rem',
                      border: 'none',
                      borderRadius: '6px',
                      cursor: 'pointer'
                    }}
                  >
                    Google Meet
                  </button>
                  <button
                    type="button"
                    onClick={() => setMeetingType("Zoom")}
                    style={{
                      marginRight: '0.5rem',
                      backgroundColor: '#f1f2f4',
                      padding: '0.4rem 0.8rem',
                      border: 'none',
                      borderRadius: '6px',
                      cursor: 'pointer'
                    }}
                  >
                    Zoom
                  </button>
                  <button
                    type="button"
                    onClick={() => setMeetingType("Teams")}
                    style={{
                      marginRight: '0.5rem',
                      backgroundColor: '#f1f2f4',
                      padding: '0.4rem 0.8rem',
                      border: 'none',
                      borderRadius: '6px',
                      cursor: 'pointer'
                    }}
                  >
                    Teams
                  </button>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>,
    document.body
  );
}

export default TaskModal;